/* tslint:disable */
/* eslint-disable */
/**
 * CyberWell Aegis API
 * Multi-tenant case management API with JWT auth, RBAC (Casbin), audit logging, and tenant isolation.
 *
 * The version of the OpenAPI document: v1
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */

import { mapValues } from '../runtime';
/**
 * 
 * @export
 * @interface RoadmapPeriodDto
 */
export interface RoadmapPeriodDto {
    /**
     * 
     * @type {string}
     * @memberof RoadmapPeriodDto
     */
    key?: string;
    /**
     * 
     * @type {Date}
     * @memberof RoadmapPeriodDto
     */
    start?: Date;
    /**
     * 
     * @type {Date}
     * @memberof RoadmapPeriodDto
     */
    end?: Date;
}

/**
 * Check if a given object implements the RoadmapPeriodDto interface.
 */
export function instanceOfRoadmapPeriodDto(value: object): value is RoadmapPeriodDto {
    return true;
}

export function RoadmapPeriodDtoFromJSON(json: any): RoadmapPeriodDto {
    return RoadmapPeriodDtoFromJSONTyped(json, false);
}

export function RoadmapPeriodDtoFromJSONTyped(json: any, ignoreDiscriminator: boolean): RoadmapPeriodDto {
    if (json == null) {
        return json;
    }
    return {
        
        'key': json['key'] == null ? undefined : json['key'],
        'start': json['start'] == null ? undefined : (new Date(json['start'])),
        'end': json['end'] == null ? undefined : (new Date(json['end'])),
    };
}

export function RoadmapPeriodDtoToJSON(json: any): RoadmapPeriodDto {
    return RoadmapPeriodDtoToJSONTyped(json, false);
}

export function RoadmapPeriodDtoToJSONTyped(value?: RoadmapPeriodDto | null, ignoreDiscriminator: boolean = false): any {
    if (value == null) {
        return value;
    }

    return {
        
        'key': value['key'],
        'start': value['start'] == null ? undefined : ((value['start']).toISOString().substring(0,10)),
        'end': value['end'] == null ? undefined : ((value['end']).toISOString().substring(0,10)),
    };
}

